import {
  STATUS_DRAFT,
  STATUS_PENDING,
  STATUS_INVOICED,
  STATUS_PAIED,
  STATUS_DELIVERED,
  STATUS_CANCELED,
  STATUS_VALIDATED,
  DPA,
  CHECK,
} from "../../constants/transactions";
export default {
  TRANSACTIONS_LIST: "Liste des transactions DPA",
  ADD_TRANSACTION: "Ajouter une transaction DPA",
  VIEW_TRANSACTION: "Transaction",
  TRANSACTION_ADDED: "Transaction DPA ajoutée",
  EDIT_TRANSACTION: "Modifier une transaction DPA",
  TRANSACTION_UPDATED: "Transaction DPA mise à jour",
  DELETE_THIS_TRANSACTION: "Supprimer cette transaction DPA ?",
  TRANSACTION_DELETED: "Transaction DPA supprimée",
  VALIDATE_TRANSACTION: "Valider une transaction DPA",
  TRANSACTION_VALIDATED: "Transaction DPA validée",
  STATUS: "Statut",
  PRICE: "Prix",
  QTE: "Qte",
  TOTAL: "Total",
  VEHICLE: "Véhicule",
  ORGANIZATION_SELLER: "Organisation vendeur",
  ORGANIZATION_BUYER: "Organisation acheteur",
  LOCATION_SELLER: "Concession vendeur",
  LOCATION_BUYER: "Concession acheteur",
  SELLER_PAYMENT_METHOD: "Méthode de paiement (vendeur)",
  SELLER_SHIPPING_ADDRESS: "Adresse de livraison (vendeur)",
  SELLER_SHIPPING_METHOD: "Méthode de livraison (vendeur)",
  BUYER_PAYMENT_METHOD: "Méthode de paiement (acheteur)",
  BUYER_SHIPPING_ADDRESS: "Adresse de livraison (acheteur)",
  BUYER_SHIPPING_METHOD: "Méthode de livraison (acheteur)",
  CANCEL_TRANSACTION: "Annuler",
  CANCEL_TRANSACTION_QUESTION: "Annuler la transaction ?",
  TRANSACTION_CANCELED: "Transaction annulée",
  BUYER_INVOICE: "Facture acheteur",
  SELLER_INVOICE: "Facture vendeur",
  ALL_STATUS: "Tous les statuts",
  VIEW_TRANSACTION: "Transaction",
  DRAFT : "En attente de signature",
  PENDING : "En cours",
  STATUS_INVOICED : "Facturée",
  STATUS_PAIED : "Payée",
  STATUS_DELIVERED : "Livrée",
  STATUS_CANCELED : "Annulée",
  STATUS_VALIDATED : "Validée",
  SENT: "Envoyé au DPA",
  AWAITING_SIGNATURE: "En attente de signature",
  COMPLETED: "Complétée",
  REFUSED: "Refusée",
  SENT_TO_BANK: "Envoyé à la banque",
  HOLDON: "Mise en attente",
  DPA: "DPA",
  CHECK: "Chéque",
  TRANSACTION_HAS_PAYMENTS_TO_REFUND: "Cette transaction a des paiements à rembourser",
  CHANGE_TRANSACTION_BUYER: "Changer l'acheteur",
  TRANSACTION_BUYER_CHANGED: "Acheteur changé avec succès",
  CHANGE_BUYER: "Changer l'acheteur",
  ORGANIZATION_REQUIRED: "L'organisation est requise",
  LOCATION_REQUIRED: "La concession est requise",
  PRICE_REQUIRED: "Le montant est requis",
  PAYMENT_SOURCE_REQUIRED: "La source de paiement est requise",
  PAYMENT_METHOD_REQUIRED: "La méthode de paiement est requise",
  SELLER_PAYMENTS_WILL_BE_TRANSFERRED_TO_THIS_TRANSACTION: "Les paiements du vendeur seront transférés à cette transaction",
  DEPOT: "Dépôt",
  RETRAIT: "Retrait",
};
